import { useEffect, useState } from "react"

interface UseBreakpointsReturn {
	isDesktop: boolean
	isMobile: boolean
	isMaxXls: boolean
}

export function useBreakpoints(): UseBreakpointsReturn {
	const [isDesktop, setIsDesktop] = useState(false)
	const [isMobile, setIsMobile] = useState(false)
	const [isMaxXls, setIsMaxXls] = useState(false)

	useEffect(() => {
		const desktopQuery = window.matchMedia("(min-width: 1024px)")
		const mobileQuery = window.matchMedia("(max-width: 639px)")
		const isMaxXls = window.matchMedia("(max-width: 1149px)")

		const update = () => {
			setIsDesktop(desktopQuery.matches)
			setIsMobile(mobileQuery.matches)
			setIsMaxXls(isMaxXls.matches)
		}

		update() // Initial check

		desktopQuery.addEventListener("change", update)
		mobileQuery.addEventListener("change", update)
		isMaxXls.addEventListener("change", update)

		return () => {
			desktopQuery.removeEventListener("change", update)
			mobileQuery.removeEventListener("change", update)
			isMaxXls.removeEventListener("change", update)
		}
	}, [])

	return { isDesktop, isMobile, isMaxXls }
}
